import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const faqs = [{
  q: '¿Incluye dominio?',
  a: 'Sí. Registramos y configuramos tu dominio propio (tunegocio.com) sin que tengas que hacer nada técnico.'
}, {
  q: '¿Realmente en 24 horas?',
  a: 'Sí. Desde que recibimos tu información y las fotos, tu web se publica dentro de las 24 horas hábiles siguientes.'
}, {
  q: '¿Se puede editar luego?',
  a: 'No, una vez hecho el diseño, no se puede modificar a menos que se abone un porcentaje extra.'
}, {
  q: '¿Funciona en celular?',
  a: 'Todas las webs se diseñan primero para celular, donde está la mayoría de tus clientes, y se adaptan a tablet y escritorio.'
}, {
  q: '¿Incluye hosting?',
  a: 'Sí, el hosting rápido y seguro está incluido, con certificado SSL y respaldo, sin cargos ocultos.'
}];
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="w-full bg-white py-20 sm:py-28" data-id="element-53" data-mp="pg3fm3hku5or">
      <div className="mx-auto w-full max-w-3xl px-5 sm:px-8" data-id="element-54" data-mp="ufppq423z5tc">
        <SectionHeading eyebrow="FAQ" title="Preguntas frecuentes" data-id="element-55" data-mp="fk9tbse22xts" />

        <div className="mt-12 divide-y divide-black/5 overflow-hidden rounded-3xl border border-black/5 shadow-soft" data-id="element-56" data-mp="fm4ffa12cvzg">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} data-id="element-57" data-mp="biomano7ddri" data-mpi={index}>
                <h3 data-id="element-58" data-mp="biyd2dh2noy9">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors hover:bg-black/[0.02] sm:px-8" data-id="element-59" data-mp="bk9gudaiowpd">
                    <span className="text-base font-bold" data-id="element-60" data-mp="3o1o5k06ftyaa">{faq.q}</span>
                    <span className={['flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all duration-300', isOpen ? 'rotate-45 bg-brand-yellow' : 'bg-black/5'].join(' ')} data-id="element-61" data-mp="1uhmhh4y885fs">
                      <PlusIcon className="h-4 w-4 text-brand-ink" aria-hidden="true" data-id="element-62" data-mp="1ftj95owpohnt" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-63" data-mp="28gcg4p0p2d69">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: [0.22, 1, 0.36, 1]
              }} className="overflow-hidden" data-id="element-64" data-mp="23h9bh5omm8yt">
                      <p className="px-6 pb-6 pr-14 text-sm leading-relaxed text-brand-ink/60 sm:px-8" data-id="element-65" data-mp="2zonqdyt9jhfl">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}